import * as Preact from "preact"
import Pointer from "poin"
import Joyp from "joyp"

import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/admin/Dev.js"
import Navigation from "@frog/source/models/Navigation.js"
import StageModel from "@frog/source/models/Stage.js"

import "@frog/source/views/Mount.less"
import Stage from "@frog/source/views/Stage.jsx"
import DevPanes from "@frog/source/views/dev/DevPanes.jsx"
import ChapterUI from "@frog/source/views/ChapterUI.jsx"
import DevEncounterEditorScreen from "@frog/source/views/dev/DevEncounterEditorScreen.jsx"
import DevScriptImporterScreen from "@frog/source/views/dev/DevScriptImporterScreen.jsx"
import DevBattleEditorScreen from "@frog/source/views/dev/DevBattleEditorScreen.jsx"
import DevScriptEditorScreen from "@frog/source/views/dev/DevScriptEditorScreen.jsx"
import DevUiScreen from "@frog/source/views/dev/DevUiScreen.jsx"
import UnitSprite from "@frog/source/views/components/UnitSprite.jsx"
import Snow from "@frog/source/views/components/Snow.jsx"
import ModalUI from "@frog/source/views/ModalUI.jsx"
import PauseMenu from "@frog/source/views/components/PauseMenu.jsx"

import Resize from "@frog/source/utility/Resize.js"
import Audiomix from "@frog/source/juice/Audiomix.js"

import tests from "@frog/source/tests/testlist.js"
import audios from "@frog/source/data/audiotriggers.js"
import unitJobs from "@frog/source/data/unit-jobs.js"
import unitsprites from "@frog/source/data/unitsprites.js"
import preload from "@frog/source/data/preload.js"
import games from "@frog/source/data/games"

export default class Mount {
    render() {
        return (
            <div class="Mount" isDev={Dev.areDevPanelsOpen || false} gameslug={App.game?.slug}>
                <DevPanes>
                    <div class="FrameSection">
                        <Frame>
                            <PreloadedImages/>
                            <Screen/>
                        </Frame>
                    </div>
                </DevPanes>
            </div>
        )
    }
}

class Frame {
    render() {
        return (
            <div class="Frame" id="frame" onContextMenu={this.onContextMenu}>
                {this.props.children}
            </div>
        )
    }
    componentDidMount() {
        Resize({
            "width": 16,
            "height": 9,
            "domId": "frame"
        })

        const element = document.getElementById("frame")
        Pointer.listen(element)
    }
    componentDidUpdate() {
        Resize()
    }
    onContextMenu(event) {
        event.preventDefault()
    }
}

class PreloadedImages {
    render() {
        return (
            <div class="PreloadedImages">
                {Object.keys(preload.images).map((image) => {
                    return (
                        <img src={image}/>
                    )
                })}
            </div>
        )
    }
}

class Screen {
    render() {
        if(Navigation.state == undefined) {
            const Screen = SCREENS["LoadingScreen"]
            return <Screen/>
        }

        const screenName = Navigation.state.screen
        const Screen = SCREENS[screenName]

        if(Screen != undefined) {
            return <Screen/>
        } else {
            const ErrorScreen = SCREENS["ErrorScreen"]
            return <ErrorScreen message={"Could not find screen: " + screenName}/>
        }
    }
}

function LoadingScreen() {
    return (
        <div class="LoadingScreen">
            <div class="ProgressBar" style={{"width": (preload.loadedCount / preload.totalCount) * 100 + "%"}}/>
            <div class="Header Text">Loading...</div>
            <div class="Base Text">Loading...</div>
        </div>
    )
}

const SCREENS = {
    "LoadingScreen": LoadingScreen,
    "TitleScreen": function() {
        if(preload.isLoading) {
            const Screen = SCREENS["LoadingScreen"]
            return <Screen/>
        }
        return (
            <div class="TitleScreen">
                <title>{games[Navigation.state.gameSlug].title}</title>
                <div class="Splash" isSplashing={Navigation.state.isSplashing + ""}
                    onClick={() => Navigation.state.isSplashing = false}>
                    <div class="Logo1">Goodberry Games presents</div>
                    <div class="Logo2">{games[Navigation.state.gameSlug].introduction}</div>
                </div>
                <div class="Main">
                    {(TITLE_CONTENTS[Navigation.state.gameSlug] || TITLE_CONTENTS["default"])()}
                    <div class="DevHellButton" onClick={() => Navigation.go("/dev")}>Dev Hell</div>
                    <div class="ProductionButton" onClick={() => window.location.search = "/production/"}>Production</div>
                </div>
            </div>
        )
    },
    "PartyScreen": function() {
        if(App.game == undefined) return
        if(App.game.overworld == undefined) return
        if(App.game.player == undefined) return
        let stage = App.getActiveStage()
        return (
            <div class="PartyScreen">
                <div class="UnitSection">
                    <div class="UnitList">
                        {Object.values(App.game.player.party.units).map((unit) => {
                            return (
                                <div class="UnitStub" onClick={() => Navigation.state.selectedUnitKey = unit.key}>
                                    <div class="Letter">{unit.name.charAt(0)}</div>
                                </div>
                            )
                        })}
                    </div>
                    {Navigation.state.selectedUnitKey != undefined && App.game.player.party.units[Navigation.state.selectedUnitKey] != undefined && (
                        <div class="SelectedUnit">
                            <div class="Name">
                                {App.game.player.party.units[Navigation.state.selectedUnitKey].name}
                            </div>
                            <div class="Items">
                                <div class="Item">
                                    {App.game.player.party.units[Navigation.state.selectedUnitKey].primaryItem?.name}
                                </div>
                                <div class="Item">
                                    {App.game.player.party.units[Navigation.state.selectedUnitKey].secondaryItem?.name}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div class="ItemSection">
                    {Object.values(App.game.player.inventory.items).map((item) => {
                        return (
                            <div class="ItemStub" onClick={() => {
                                if(Navigation.state.selectedUnitKey == undefined) return
                                App.game.player.party.units[Navigation.state.selectedUnitKey].secondaryItem = item
                            }}>
                                {item.name}
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    },
    "OverworldScreen": function() {
        if(App.game == undefined) return
        if(App.game.overworld == undefined) return
        let stage = App.getActiveStage()
        return (
            <div class="OverworldScreen">
                <ModalUI stage={stage}/>
                <div class="Map" style={{"background-image": App.game.overworld.image && "url(" + App.game.overworld.image + ")"}}/>
                {App.game.overworld.locations && Object.values(App.game.overworld.locations).map((location) => {
                    return (
                        <div class="Location" key={location.key}
                            onClick={() => {
                                if(location.isReachable == true
                                && location.isFinished != true) {
                                    Navigation.go("/games/" + App.game.slug + "/chapters/" + location.chapterKey)
                                }
                            }}
                            style={{"left": location.position.x + "em", "top": location.position.y + "em"}}
                            isDisplayed={location.isDisplayed} isDisplayedAsEventualRoute={location.isDisplayedAsEventualRoute}
                            isReachable={location.isReachable} isFinished={location.isFinished}>
                            <span class="Text">{location.text}</span>
                            <img class="Icon" src={location.icon} style={{
                                "width": location.spritesize == "big" ? "2em" : "1em",
                            }}/>
                        </div>
                    )
                })}
                {App.game.overworld?.player?.position && (
                    <div class="Player" style={{
                        "left": App.game.overworld.player.position.x + "em",
                        "top": App.game.overworld.player.position.y + "em",
                    }}/>
                )}
                {App.game.overworld.routes && Object.keys(App.game.overworld.routes).map((routeKey) => {
                    const route = App.game.overworld.routes[routeKey]
                    return (
                        <div class="Route" key={routeKey}
                            style={{"left": route.x + "em", "top": route.y + "em"}}
                            isReachable={route.isReachable} isDisplayed={route.isDisplayed}/>
                    )
                })}
            </div>
        )
    },
    "ChapterScreen": function() {
        if(App.game == undefined) return
        if(preload.isLoading) {
            const Screen = SCREENS["LoadingScreen"]
            return <Screen/>
        }
        let stage = App.getActiveStage()
        if(Dev.inProtoMode == true) {
            if(Dev.mode == "battle") {
                return EDITOR_SCREENS["DevBattleEditorScreen"]()
            } else if(Dev.mode == "geography") {
                return EDITOR_SCREENS["DevGeographyEditorScreen"]()
            } else if(Dev.mode == "scripts") {
                return EDITOR_SCREENS["DevScriptEditorScreen"]()
            }
        }
        return (
            <div class="ChapterScreen"
                onMouseDown={(event) => App.game.chapter.selection.start()}
                onMouseUp={(event) => App.game.chapter.selection.finish()}
                onDblClick={() => {App.game.chapter.selection.doubleStart()}}
                onContextMenu={(event) => App.game.chapter.selection.cancel()}>
                <title>{games[App.game.slug].title}</title>
                <Stage stage={stage}/>
                <ChapterUI stage={stage}/>
                <ModalUI stage={stage}/>
                <PauseMenu/>
                <Snow stage={stage}/>
            </div>
        )
    },
    "CreditsScreen": function() {
        return (
            <div class="CreditsScreen" gameSlug={Navigation.state.gameSlug}>
                <div class="Content">
                    <div class="Title">
                        <span>{games[Navigation.state.gameSlug]?.title}</span>
                    </div>
                    {games[Navigation.state.gameSlug]?.credits && <div class="Credits">
                        <div>A goodberry game by</div>
                        <div class="BigContributors">
                            {[0, 1, 2].map((index) => {
                                return (
                                    <div class="Contributor">
                                        <div class="Sprite" style={{"background-image": "url(" + unitsprites.images[Object.values(games[Navigation.state.gameSlug].player.party.units)[index].imageKey] + ")"}}/>
                                        <small class="Name">{games[Navigation.state.gameSlug]?.credits[index]}</small>
                                    </div>
                                )
                            })}
                        </div>
                        {games[Navigation.state.gameSlug]?.credits.map((name, index) => {
                            if(index < 3) return
                            return (
                                <small>{name}</small>
                            )
                        })}
                    </div>}
                    <div class="Thanks">
                        Thanks for playing!!
                    </div>
                    <div class="Prompt">
                        <span>Keep up to date:<br/>Subscribe to our email list</span>
                    </div>
                    <div class="CallToAction">
                        <form action="https://games.us13.list-manage.com/subscribe/post?u=2107e75aa44205e6387eb52d5&amp;id=0facb46663&amp;f_id=002760e1f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_self" novalidate="">
                            <div class="BoxButNotThatBox">
                                <label for="mce-EMAIL">Email Address</label>
                                <div class="Inputs">
                                    <input type="email" name="EMAIL" class="required email" id="mce-EMAIL" required=""/>
                                    <input type="submit"/>
                                </div>
                            </div>
                            <div aria-hidden="true" style="position: absolute; left: -5000px;">
                                <input type="text" name="b_2107e75aa44205e6387eb52d5_0facb46663" tabindex="-1" value=""/>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
        // return (
        //     <div class="CreditsScreen">
        //         <div class="Content">
        //             <div class="Title">
        //                 <span>This Be Mutiny</span>
        //             </div>
        //             <div class="Credits">
        //                 <div>A goodberry game by</div>
        //                 <div>Andrew Goodenough</div>
        //                 <div>Doc McPherson</div>
        //                 <div>Anna Arkhipova</div>
        //                 <div>Vitor Amado</div>
        //                 <div>So many artists</div>
        //             </div>
        //             <div class="Thanks" onMouseDown={() => Navigation.go("/games/dungeon")}>
        //                 Thanks for playing!!
        //             </div>
        //         </div>
        //     </div>
        // )
    },
    "ErrorScreen": function({message}) {
        return (
            <div class="ErrorScreen">
                <title>Frog</title>
                {Navigation.state.message || message || "Something went wrong."}
            </div>
        )
    },
    "DevHellScreen": function() {
        return (
            <div class="DevHellScreen">
                <title>Frog</title>
                <div class="Header">Welcome to Dev Hell</div>
                <div class="Links">
                    <div class="Link" onClick={() => Navigation.go("/dev/tests")} result="">Tests</div>
                    <div class="Link" onClick={() => Navigation.go("/dev/ui")}>Game UI</div>
                    <div class="Link" onClick={() => Navigation.go("/dev/audio")}>Audio</div>
                    <div class="Link" onClick={() => Navigation.go("/dev/scripts/import")}>Script Importer</div>
                    <div class="Link" onClick={() => Navigation.go("/dev/imports")}>Images</div>
                </div>
            </div>
        )
    },
    "DevTestListScreen": function() {
        return (
            <div class="DevTestListScreen">
                <title>Frog</title>
                <div class="Header">Tests</div>
                <div class="Tests">
                    {tests.map((test) => {
                        return (
                            <div class="Test" status={test.status || "loading"}
                                onClick={() => Navigation.go("/dev/tests/" + test.slug)}>
                                {test.slug}
                            </div>
                        )
                    })}
                </div>
                <div class="Tests">
                    {Object.values(games).map((game) => {
                        const gametests = game.tests || {}
                        return Object.keys(gametests).map((key) => {
                            const test = gametests[key]
                            return (
                                <div class="Test" status={test.status || "loading"}
                                    onClick={() => Navigation.go("/dev/savetests/" + test.gameSlug + "/" + key)}>
                                    {game.slug + "/" + key}
                                </div>
                            )
                        })
                    })}
                </div>
            </div>
        )
    },
    "DevTestScreen": function() {
        return (
            <div class="DevTestScreen" status={Navigation.state.test.status}>
                <title>Frog</title>
                <div class="TestSlug">{Navigation.state.test.slug}</div>
                <div class="Message">{Navigation.state.test?.error?.message}</div>
            </div>
        )
    },
    "DevSavetestScreen": function() {
        return (
            <div class="DevTestScreen" status={Navigation.state.test.status}>
                <title>Frog</title>
                <div class="TestSlug">{Navigation.state.test.name}</div>
                <div class="Message">{Navigation.state.test?.error?.message}</div>
            </div>
        )
    },
    "DevImportsScreen": function() {
        return (
            <div class="DevListScreen">
                <div class="Header">Imported Images</div>
                <div class="Unit">
                    <div class="Image Column"/>
                    <div class="Name Column">Name</div>
                    <div class="Number Column">HP</div>
                    <div class="Number Column">PW</div>
                    <div class="Number Column">MR</div>
                    <div class="Number Column">AR</div>
                    <div class="String Column">Type</div>
                    <div class="String Column">Element</div>
                </div>
                <div class="Units">
                    {Object.keys(preload.images).map((imageKey) => {
                        const image = preload.images[imageKey]
                        return (
                            <div class="Unit">
                                <div class="Image Column">
                                    <img src={image.element.src}/>
                                </div>
                                <div class="Image Column">
                                    <img src={image.palettes?.red}/>
                                </div>
                                <div class="Image Column">
                                    <img src={image.palettes?.blue}/>
                                </div>
                                <div class="Name Column">{imageKey}</div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    },
    "DevScriptImporterScreen": function() {
        return <DevScriptImporterScreen/>
    },
    "DevUiListScreen": function() {
        return (
            <div class="DevUiListScreen">
                <title>Frog</title>
                <div class="Header">Game Ui</div>
                <div class="UIs">
                    <a class="UI" href="#/dev/ui/Dialogue">Dialogue Modal</a>
                    <a class="UI" href="#/dev/ui/ChapterStart">Chapter Start Modal</a>
                    <a class="UI" href="#/dev/ui/PlayerTurnStart">Turn Start Modal - Player Phase</a>
                    <a class="UI" href="#/dev/ui/NonPlayerTurnStart">Turn Start Modal - Non-Player Phase</a>
                    <a class="UI" href="#/dev/ui/ChapterFailure">Chapter Failure Modal</a>
                    <a class="UI" href="#/dev/ui/ChapterSuccess">Chapter Success Modal</a>
                    <a class="UI" href="#/dev/ui/ChapterSuccessClassic">Chapter Success Modal - Obsolete</a>
                    <a class="UI" href="#/dev/ui/CharacterLevelUp">Character Levelup Modal</a>
                    <a class="UI" href="#/dev/ui/CharacterSplash">Character Recruitment Modal</a>
                    <a class="UI" href="#/title">Title Screen</a>
                    <a class="UI" href="#/">Title Screen - with Splash</a>
                    <a class="UI" href="#/options">Options Screen</a>
                    <a class="UI" href="#/credits">Credits Screen</a>
                    <a class="UI" href="#/dev/ui/Loading">Loading Screen</a>
                </div>
            </div>
        )
        // <div class="UI">Obsolete: Character Drafting</div>
        // <div class="UI">Obsolete: Declaration?</div>
        // <div class="UI">Combat HUD</div>
        // <div class="UI">Combat HUD, Hidden Unit Information</div>
        // <div class="UI">Combat HUD, Tutorial Popups</div>
        // <div class="UI">Pause Menu</div>
        // <div class="UI">Overworld - Unfolding Revealing</div>
        // <div class="UI">Pre-Combat Prepare</div>
    },
    "DevUiScreen": DevUiScreen,
}

const EDITOR_SCREENS = {
    "DevGeographyEditorScreen": function() {
        return <DevEncounterEditorScreen/>
    },
    "DevBattleEditorScreen": function() {
        return <DevBattleEditorScreen/>
    },
    "DevScriptEditorScreen": function() {
        return <DevScriptEditorScreen/>
    },
}

const TITLE_CONTENTS = {
    "default": function() {
        const game = games[Navigation.state.gameSlug]
        if(game == undefined) return
        if(Joyp.wasJustPressed(0, "start-button")) {
            if(Navigation.state.isSplashing !== false) {
                Navigation.state.isSplashing = false
            } else {
                Navigation.go("/games/" + game.slug + "/chapters/" + (game.firstChapterKey || "1"))
            }
        }

        var savegame
        try {
            savegame = JSON.parse(localStorage.getItem(game.slug + "_savegame"))
        } catch (e) {
            savegame = undefined
        }

        let loadButton = (
            <div class="Button" isDead="true">Load Game</div>
        )
        if(savegame != undefined) {
            loadButton = (
                <div class="Button" onClick={() => Navigation.go("/games/" + game.slug + "/reload")}>Load Game</div>
            )
        }

        function onClick() {
            if(game.openingEvents != undefined) {
                App.load({"game": {...game}})
                App.sequence = {}
                App.sequence.steps = StageModel.processEventSteps({}, game.openingEvents())
            } else {
                Navigation.go("/games/" + game.slug + "/chapters/" + (game.firstChapterKey || "1"))
            }
        }

        return (
            <div class="Default TitleContents">
                <div class="Title">{game.title || game.slug}</div>
                <div class="Subtitle">{game.subtitle}</div>
                <div class="Button" onClick={onClick}>New Game</div>
                {loadButton}
            </div>
        )
    },
    "horror": function() {
        return (
            <div class="Horror">
                <div class="TitleContents">
                    <img class="Title" src={require("@frog/source/assets/images/horror-tactics/titlescreen-title.png")}/>
                    <div class="Button" onClick={() => Navigation.go("/games/horror/chapters/1")}>Play!</div>
                </div>
            </div>
        )
    },
    "pirates": function() {
        if(Joyp.wasJustPressed(0, "start-button")) {
            if(Navigation.state.isSplashing !== false) {
                Navigation.state.isSplashing = false
            } else {
                Navigation.go("/games/pirates/chapters/ship")
            }
        }

        return (
            <div class="Pirates TitleContents">
                <div class="Title">This Be Mutiny</div>
                <div class="Button" onClick={() => Navigation.go("/games/pirates/chapters/ship")}>Play!</div>
            </div>
        )
    }
}
